module.exports = __webpack_public_path__ + "static/media/subscription-icon.930db0b0.svg";